import React from 'react'
import {Stack} from '@mui/material'
import {FieldValues, useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {ReferralCodeSchema} from '@/helpers/Validators'
import Input from '@/components/UI/input/Input'
import HoverButton from '@/components/UI/button/HoverButton'
import UserService from '@/services/api/User'
import useFetching from '@/hooks/useFetching'
import TransCustom from '@/components/UI/i18next'

const Index = ({
  getExternalReferrals,
  code,
}: {
  getExternalReferrals: () => void
  code?: string
}) => {
  const {
    register,
    handleSubmit,
    setError,
    setValue,
    formState: {errors},
  } = useForm({
    mode: 'all',
    resolver: yupResolver(ReferralCodeSchema),
    defaultValues: {code: code || ''},
  })

  const [sendReferralCode, isLoad] = useFetching(async (code: string) => {
    try {
      const response = await UserService.editProfile({referral_code: code})
      if (response.status === 200) {
        getExternalReferrals()
      }
    } catch (e: any) {
      if (e.response && e.response.data) {
        setError('code', {message: e.response.data.message})
      }
    }
  })

  const onSubmit = async ({code}: FieldValues) => {
    void sendReferralCode(code)
  }

  return (
    <Stack
      marginTop="-40px"
      width="100%"
      alignItems="center"
      justifyContent="center"
      height="100%"
      position="relative">
      <Stack width="55%" gap="70px">
        <TransCustom
          i18nKey="1403"
          textAlign="center"
          variant="button"
          style={{wordBreak: 'break-word'}}
        />
        <form>
          <Input
            {...register('code')}
            fullWidth
            textalign="center"
            error={!!errors.code}
            helperText={errors.code ? errors.code.message : ''}
            placeholderalign="center"
            placeholder="Referral code"
            variant="standard"
            color="warning"
            onChange={(e) => setValue('code', e.target.value)}
          />
        </form>
        <HoverButton
          disabled={isLoad}
          height="50px"
          fontSize="16px"
          fontWeight="500"
          fullWidth
          onClick={handleSubmit(onSubmit)}>
          Join this system
        </HoverButton>
      </Stack>
    </Stack>
  )
}

export default Index
